import React from "react";
import styles from "./styles/question-answer.module.scss";

type QuestionAnswerProps = {
  question: string;
  answer: string;
};

const QuestionAnswer = ({ question, answer }: QuestionAnswerProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.question}>{question}</div>
      <div className={styles.answer}>{answer}</div>
    </div>
  );
};

export default QuestionAnswer;
